(function() {
  'use strict';

  angular.module('ringbaPortal').directive('trClipboard', trClipboard);

  function trClipboard (
    $timeout,
    clipboardService
  ) {
    const directive = {
      restrict: 'A',
      scope: {
        onCopied: '&',
        onError: '&',
        copyText: '<',
        supported: '=?'
      },
      link: link
    };
    return directive;

    function link(scope, element) {
      scope.supported = clipboardService.supported;

      element.on('click', function () {
        try {
          clipboardService.copyText(scope.copyText, element[0]);
          angular.element(element).find('i').addClass('text-success');
          $timeout(function () {
            angular.element(element).find('i').removeClass('text-success');
          }, 300);
          if (angular.isFunction(scope.onCopied)) {
            scope.$evalAsync(scope.onCopied());
          }
        } catch (err) {
          if (angular.isFunction(scope.onError)) {
            scope.$evalAsync(scope.onError({err: err}));
          }
        }
      });
    }
  }
})();
